var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgField(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.4587 8.99998C8.4587 9.9093 8.81993 10.7814 9.46291 11.4243C10.1059 12.0673 10.978 12.4286 11.8873 12.4286C12.7966 12.4286 13.6687 12.0673 14.3116 11.4243C14.9546 10.7814 15.3158 9.9093 15.3158 8.99998C15.3158 8.09067 14.9546 7.2186 14.3116 6.57562C13.6687 5.93263 12.7966 5.57141 11.8873 5.57141C10.978 5.57141 10.1059 5.93263 9.46291 6.57562C8.81993 7.2186 8.4587 8.09067 8.4587 8.99998ZM1.60156 5.57141H5.03013V12.4286H1.60156V5.57141ZM18.7444 5.57141H22.173V12.4286H18.7444V5.57141Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.8873 1V17M1.60156 3.28571C1.60156 2.67951 1.84238 2.09812 2.27103 1.66947C2.69969 1.24082 3.28107 1 3.88728 1H19.8873C20.4935 1 21.0749 1.24082 21.5035 1.66947C21.9322 2.09812 22.173 2.67951 22.173 3.28571V14.7143C22.173 15.3205 21.9322 15.9019 21.5035 16.3305C21.0749 16.7592 20.4935 17 19.8873 17H3.88728C3.28107 17 2.69969 16.7592 2.27103 16.3305C1.84238 15.9019 1.60156 15.3205 1.60156 14.7143V3.28571Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgField);
export default __webpack_public_path__ + "static/media/field.25f1adb488409e3d736ce1bf83b58a63.svg";
export { ForwardRef as ReactComponent };